export const widgetName = 'serp';
export const widgetDisplayName = 'SERP';
export const widgetCategory = 'Reply.com';
export const widgetSelector = 'serp';

export const implictReferenceCMSContentType: string = 'article';
export const defaultItemsLimit: number = 10;